let suppressMutationSuccessDepth = 0
let suppressMutationErrorDepth = 0

export const enableOnboardingSilentMutationToasts = (options?: {
  errors?: boolean
}): void => {
  suppressMutationSuccessDepth += 1
  if (options?.errors) {
    suppressMutationErrorDepth += 1
  }
}

export const disableOnboardingSilentMutationToasts = (): void => {
  if (suppressMutationSuccessDepth > 0) {
    suppressMutationSuccessDepth -= 1
  }
  if (suppressMutationErrorDepth > 0) {
    suppressMutationErrorDepth -= 1
  }
}

export const shouldSuppressOnboardingMutationSuccessToasts = (): boolean =>
  suppressMutationSuccessDepth > 0

export const shouldSuppressOnboardingMutationErrorToasts = (): boolean =>
  suppressMutationErrorDepth > 0
